import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import '@css/index.scss'
import { getImage } from "@public/ulits";
import Footer from "@public/components/Footer";
import Header from "@components/Header";
import { api } from '@public/ulits/api';
import usePageLang from '@public/hooks/usePageLang';
import { t } from '@/locales';
import { GlobalOutlined, PhoneOutlined, MailOutlined } from "@ant-design/icons";
import { Spin } from 'antd';

export default () => {
    const [employees, setEmployees] = useState(null);
    const [loading, setLoading] = useState(true);
    const { pick } = usePageLang();

    useEffect(() => {
        api.getEmployeeList()
            .then(res => {
                if (res && res.data) {
                    setEmployees(res.data.filter(e => e.status === 1));
                }
            })
            .catch(() => {})
            .finally(() => setLoading(false));
    }, []);

    return (
        <div className={`page-index page-employee`}>
            <div className="w-full">
                <Header bgColor="#0a1628" />
                <div className="lg:w-[70%] lg:px-0 px-5 mx-auto lg:pt-[140px] pt-[90px] lg:pb-[66px] pb-6">
                    <h1 className="lg:text-[40px] text-2xl font-bold text-white lg:mb-8 mb-6">{t('employee.ourAgents')}</h1>
                    {loading ? (
                        <div className="flex justify-center py-20">
                            <Spin size="large" />
                        </div>
                    ) : employees && employees.length > 0 ? (
                        <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
                            {employees.map(emp => (
                                <Link to={`/employee/${emp.id}`} key={emp.id}>
                                    <div className="employee-card bg-[rgba(255,255,255,0.06)] rounded-xl p-6 text-center
                                        hover:bg-[rgba(255,255,255,0.12)] transition-all duration-300 cursor-pointer
                                        border border-[rgba(255,255,255,0.08)] hover:border-[rgba(255,255,255,0.2)]
                                        hover:-translate-y-1">
                                        {emp.avatar ? (
                                            <img className="w-full aspect-[3/4] object-cover rounded-t-xl mb-4"
                                                src={emp.avatar} alt={pick(emp.name_en, emp.name_zh)} />
                                        ) : (
                                            <div className="w-full aspect-[3/4] bg-[rgba(255,255,255,0.03)] rounded-t-xl mb-4"></div>
                                        )}
                                        <h3 className="text-white lg:text-xl text-lg font-bold">{pick(emp.name_en, emp.name_zh)}</h3>
                                        {emp.license && (
                                            <p className="text-[rgba(255,255,255,0.5)] text-sm mt-1">{t('employee.license')} {emp.license}</p>
                                        )}
                                        {pick(emp.title_en, emp.title_zh) && (
                                            <p className="text-gold text-sm mt-1 font-medium">{pick(emp.title_en, emp.title_zh)}</p>
                                        )}
                                        <hr className="border-[rgba(255,255,255,0.08)] my-4" />
                                        <div className="text-left space-y-2 text-[rgba(255,255,255,0.7)] text-sm">
                                            {emp.languages && (
                                                <p className="flex items-center gap-2">
                                                    <GlobalOutlined className="text-gold shrink-0" />
                                                    <span>{emp.languages}</span>
                                                </p>
                                            )}
                                            {emp.phone && (
                                                <p className="flex items-center gap-2">
                                                    <PhoneOutlined className="text-gold shrink-0" />
                                                    <a href={`tel:${emp.phone}`} className="hover:text-gold transition-colors">{emp.phone}</a>
                                                </p>
                                            )}
                                            {emp.email && (
                                                <p className="flex items-center gap-2">
                                                    <MailOutlined className="text-gold shrink-0" />
                                                    <a href={`mailto:${emp.email}`} className="hover:text-gold transition-colors">{emp.email}</a>
                                                </p>
                                            )}
                                        </div>
                                    </div>
                                </Link>
                            ))}
                        </div>
                    ) : null}
                </div>
                <Footer />
            </div>
        </div>
    )
}
